import React, { lazy } from 'react';
import type { ComponentType, PropsWithChildren, ReactElement } from 'react';

const CopyToClipboard = lazy(
  () => import('react-copy-to-clipboard')
) as ComponentType<CopyTextProps>;

interface CopyTextProps extends PropsWithChildren {
  text: string;
  fallback?: ReactElement<any>;
}

const CopyText = ({ text, children, fallback }: CopyTextProps) => (
  <CopyToClipboard fallback={fallback} text={text}>
    {children}
  </CopyToClipboard>
);

export default CopyText;
